<script setup lang="ts">
import type { IUserBonus } from "@/app/shared/types/User.type"
import { cancelUserBonus } from "@/app/api"
import { useI18n } from "@/app/composables/useI18n"
import ConfirmationModal from "@/app/shared/components/ConfirmationModal.vue"
import { ref } from "vue"
import CasinoBonusModal from "../../modal/CasinoBonusModal.vue"

const props = withDefaults(
  defineProps<{
    bonus: IUserBonus;
    title: string;
    expire: string;
    icon: string;
    value: string;
    info?: boolean;
  }>(),
  {
    info: true
  }
);

const showInfoModal = ref(false)
const showConfirmationModal = ref(false)
const { t } = useI18n()

function handleShowCasinoBonusModal() {
  showInfoModal.value = false;
}

async function handleCancelUserBonus(confirm: boolean) {
  if (!confirm) {
    showConfirmationModal.value = false
    return
  }

  try {
    await cancelUserBonus(props.bonus.id);
  } catch (error) {
    console.error("Error cancelling user bonus:", error);
  }
}
</script>

<template>
  <div>
    <CasinoBonusModal
      :show="showInfoModal"
      :bonus="bonus"
      @close="handleShowCasinoBonusModal"
    />
    <div class="active-block">
      <div class="active-title">
        <div>{{ title }}</div>
        <img
          v-if="info"
          class="info-light"
          src="/assets/images/info.svg"
          alt=""
          @click="showInfoModal = true"
        />
      </div>
      <div class="currency">
        <img :src="icon" alt="" class="currency-icon" />
        <div>{{ value }}</div>
      </div>
      <div v-if="expire !== null" class="expires">
        <span>
          {{ expire }}
        </span>
        <button @click="showConfirmationModal = true">
          {{ t('general.cancel_bonus') }}
        </button>
      </div>
    </div>
    <ConfirmationModal :show="showConfirmationModal" :message="t('casino.confirmationCancelText')" @confirm-handler="handleCancelUserBonus" @close="showConfirmationModal = false" />
  </div>
</template>

<style lang="scss" scoped>
.currency-icon {
  width: 16px;
  height: 21px;
}

.active-block {
  background: var(--be-big-card-bg);
  padding: 16px;
  border-radius: 8px;
}

.active-title {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin-bottom: 11px;
  font-family: Poppins-reg;
}

.currency {
  display: flex;
  align-items: center;
  gap: 0 4px;
  font-family: Poppins-bold;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
}

.info-light {
  opacity: 0.3;
  cursor: pointer;
}

.expires {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: #fff;
  font-family: Poppins-reg;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-top: 5px;

  span {
    opacity: 0.3;
  }

  button {
    font-family: Poppins-bold;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    color: var(--be-heart);

    &:hover {
      opacity: 0.5;
      transition: opacity 0.3s ease-in;
    }
  }
}
</style>
